import { Star } from 'lucide-react';
import type { ReactElement } from 'react';
import { IconButton } from '@/components/IconButton';
import { cn } from '@/lib/cn';
import { useInterfaceLanguage } from '@/lib/interface-language';

export interface BoardStarButtonProps {
  boardTitle: string;
  starred: boolean;
  busy?: boolean | undefined;
  className?: string | undefined;
  onToggle: (nextStarred: boolean) => void;
}

export function BoardStarButton({
  boardTitle,
  starred,
  busy,
  className,
  onToggle,
}: BoardStarButtonProps): ReactElement {
  const { t } = useInterfaceLanguage();

  return (
    <IconButton
      size="sm"
      label={t(starred ? 'boards.unstarBoard' : 'boards.starBoard', {
        board: boardTitle,
      })}
      aria-pressed={starred}
      busy={busy === true}
      className={cn(
        starred
          ? 'text-accent hover:bg-surface-raised hover:text-accent'
          : 'text-on-board hover:bg-surface-raised hover:text-ink',
        className,
      )}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        if (busy === true) return;
        onToggle(!starred);
      }}
    >
      <Star
        aria-hidden="true"
        className="size-4"
        fill={starred ? 'currentColor' : 'none'}
      />
    </IconButton>
  );
}
